import React from "react";

import { Header, HeaderNavigation } from "../../Components";
import { BackgroundLogin } from "./Components";

import {
  SignupContainerStyled,
  Container,
  HeaderContainer,
} from "./ForgotPassword.styled";

interface ForgotPasswordScreenProps {
  exitJourney(): void;
}

export const ForgotPasswordScreen: React.FC<ForgotPasswordScreenProps> = ({
  children,
  exitJourney,
}) => {
  return (
    <div>
      <HeaderContainer>
        <Header />
      </HeaderContainer>
      <SignupContainerStyled>
        <BackgroundLogin />
        <Container>
          <HeaderNavigation onClick={exitJourney} type="close" />
          <h2>Digite a nova senha</h2>
          {children}
        </Container>
      </SignupContainerStyled>
    </div>
  );
};
